document.addEventListener('DOMContentLoaded', function () {
  // TEGEN 30th October 2026: colour gallery is written for the denim set only (Dark/Light/Medium Denim).
  // Stop on every other product so it doesn't hide photos. Proper fix (read colour after | in alt text) to follow.
  if (window.location.pathname.indexOf('/products/handmade-children-s-denim-accessory-set') === -1) return;

  var itemSel = '.product__thumbnail-item';

  function colourFromAlt(alt) {
    if (!alt) return null;
    var a = alt.toLowerCase();
    if (a.indexOf('dark') !== -1) return 'Dark Denim';
    if (a.indexOf('light') !== -1) return 'Light Denim';
    if (a.indexOf('medium') !== -1) return 'Medium Denim';
    return null;
  }

  function colourOfItem(item) {
    var img = item.querySelector('img');
    return colourFromAlt(img ? img.getAttribute('alt') : null);
  }

  function selectColour(colour) {
    var radio = document.querySelector('input[type="radio"][name="option1"][value="' + colour + '"]');
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      radio.click();
    }
  }

  function filterThumbs(colour) {
    document.querySelectorAll(itemSel).forEach(function (item) {
      var c = colourOfItem(item);
      item.style.display = (!c || c === colour) ? '' : 'none';
    });
  }

  // Клик по миниатюре: ждём, пока тема закончит свою обработку, и потом переключаем цвет
  document.addEventListener('click', function (e) {
    var item = e.target.closest(itemSel);
    if (!item) return;
    var c = colourOfItem(item);
    if (!c) return;
    setTimeout(function () {
      selectColour(c);
      filterThumbs(c);
    }, 50);
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('input[type="radio"][name="option1"]')) {
      filterThumbs(e.target.value);
    }
  });

  var checked = document.querySelector('input[type="radio"][name="option1"]:checked');
  if (checked) filterThumbs(checked.value);
});